var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCheckBlue = function SvgCheckBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "checkmarkSvg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 13.3 9.2",
    style: {
      enableBackground: "new 0 0 13.3 9.2"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.8,0c-0.1,0-0.3,0.1-0.4,0.2L4.6,7.9L0.9,4.2C0.8,4.1,0.7,4.1,0.5,4.1c0,0,0,0,0,0c-0.1,0-0.3,0.1-0.4,0.2 c-0.2,0.2-0.2,0.5,0,0.7L4.2,9C4.4,9.2,4.8,9.2,5,9l8.2-8.2c0.1-0.1,0.2-0.2,0.2-0.4s-0.1-0.3-0.2-0.4C13,0.1,12.9,0,12.8,0z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check_blue.3aae83e7.svg";
export { ForwardRef as ReactComponent };